export default function validateEmailFormat(email) {
  // eslint-disable-next-line max-len
  const regexp = new RegExp(/^.*[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?:\.[a-zA-Z0-9-]+)*$/);
  return regexp.test(email);
}
